const buttons = document.querySelectorAll(".territory-tabs__tab");
const contents = document.querySelectorAll(".territory-tabs__tabs-content");

if (buttons.length > 0 && contents.length > 0) {
  buttons[0].classList.add("isActive");
  contents[0].classList.add("isActive");
}

buttons.forEach((button, index) => {
  button.addEventListener("click", () => {
    buttons.forEach((btn) => btn.classList.remove("isActive"));
    contents.forEach((content) => content.classList.remove("isActive"));
    button.classList.add("isActive");
    if (contents[index]) {
      contents[index].classList.add("isActive");
    }
  });
});
